import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Wrapper(props) {
  return (
    <div
      tabIndex={0}
      className={`${style.HeatBlockWrapper} ${props.className} `}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};
